export default {"src":"/_next/static/media/ico_circle.79eea546.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};